<script setup lang="ts">
defineProps<{
  direction: 'left' | 'right';
  disabled?: boolean;
}>();

defineEmits<{
  click: [];
}>();
</script>

<template>
  <button
    :class="$style.navArrow"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <svg
      v-if="direction === 'left'"
      fill="none"
      height="13"
      viewBox="0 0 8 13"
      width="8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.68611e-06 6.39535L0.609085 7.00443L5.78358 12.1789L6.39535 12.7907L7.61621 11.5698L7.00713 10.9608L2.44172 6.39535L7.00443 1.82994L7.61621 1.22086L6.39535 -1.06731e-07L5.78627 0.609081L0.61178 5.78357L4.68611e-06 6.39535Z"
        fill="white"
      />
    </svg>
    <svg
      v-else
      fill="none"
      height="13"
      viewBox="0 0 8 13"
      width="8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.61621 6.39536L7.00713 5.78628L1.83263 0.611788L1.22086 1.23978e-05L0 1.22087L0.609081 1.82995L5.17449 6.39536L0.611776 10.9608L0 11.5699L1.22086 12.7907L1.82994 12.1816L7.00443 7.00714L7.61621 6.39536Z"
        fill="white"
      />
    </svg>
  </button>
</template>

<style module lang="postcss">
.navArrow {
  @apply flex items-center justify-center disabled:opacity-50;
  border-radius: 5.11px;
  border: 1.022px solid rgba(255, 255, 255, 0.1);
  padding: 4px 7px;
  min-width: 24px;
  min-height: 24px;
}
</style>
